'use strict';

export default class Overlay {
	
	constructor(params) {
		this.params = params || {};
		this.init();
	}
	
	
	init() {
		if( this.params.hasOwnProperty('selector') ) {
			const el = document.querySelector(this.params.selector);
			if( el )
				return this.openHtmlElement(el);
			
			return false;
		}
		
		if( this.params.hasOwnProperty('element') ) {
			return this.openHtmlElement(this.params.element);
		}
		
		if( this.params.hasOwnProperty('url') ) {
			return this.openAjax(this.params.url);
		}
		
		if( this.params.hasOwnProperty('string') ) {
			return this.openString(this.params.string);
		}
		
		return false;
	}
	
	
	opentHtmlElement(element) {
		return this.open(element);
	}
	
	
	openAjax(url) {
		const _this = this;
		fetch(url).then(response => response.text()).then(html => {
			_this.open(html);
		});
	}
	
	
	openString(str) {
		return this.open(str);
	}
	
	
	open(html) {
		const _this = this;
		const config = this.getConfig();
		
		// clean existing elements
		this.close();
		
		// build new element
		const wrapper = document.createElement('div');
		wrapper.classList.add(config.classNames.wrapper);
		
		const typeClassName = this.params.type === 'iframe' ? 'type-iframe' : 'type-inline';
		wrapper.classList.add(typeClassName);
		
		const clickHolder = document.createElement('div');
		clickHolder.classList.add(config.classNames.click);
		clickHolder.addEventListener('click', event => { 
			event.preventDefault();
			_this.close(); 
		});
		wrapper.appendChild(clickHolder);
		
		const main = document.createElement('div');
		main.classList.add(config.classNames.main);
		wrapper.appendChild(main);
		
		const content = document.createElement('div');
		content.classList.add(config.classNames.content);
		
		if( typeof(html) === 'string' ) {
			content.innerHTML = html;
			
			const scripts = content.getElementsByTagName('script');
			for(var n = 0; n < scripts.length; n++) {
				eval(scripts[n].innerHTML);
			}
		}
		else {
			content.appendChild(html);
		}
		main.appendChild(content);
		
		document.body.appendChild(wrapper);
		
		// find any close link in content
		document.querySelectorAll('.'+ config.classNames.main +' .overlay-close').forEach(item => {
			item.addEventListener('click', event => { 
				event.preventDefault();
				_this.close(); 
			});
		});
		
		wrapper.classList.add('open');
		
		const formControl = wrapper.querySelector('input, textarea, select');
		if(formControl) 
			formControl.focus();
		
		this.dispatchEvent('open');
	}
	
	
	close() {
		const config = this.getConfig();
		const els = document.querySelectorAll('.'+ config.classNames.wrapper);
		els.forEach(el => { el.parentNode.removeChild(el); });
	}
	
	
	
	dispatchEvent(name) {
		const config = this.getConfig();
		const element = document.querySelector('.'+ config.classNames.wrapper);
		const eventName = 'Overlay.'+ name;
		window.dispatchEvent( new CustomEvent(eventName, { detail: { element: element }} ));
	}
	
	
	getConfig() {
		return {
			classNames: {
				wrapper: 'overlay-wrap',
				click: 'overlay-click-holder',
				main: 'overlay',
				content: 'overlay-contents'
			}
		};
	}
};